/**
 * drawer-overlay-guard.js — Factory 47.
 *
 * Toggles `f47-drawer-open` on <body> while any of the theme's drawers is open,
 * so CSS can hide third-party fixed widgets that would otherwise sit on top of
 * them. The theme does not set a body class of its own when a drawer opens --
 * the only signal is the `open` attribute on the drawer element -- so we watch
 * that directly.
 *
 * Additive and defensive: if anything here throws, no class is added and the
 * page behaves exactly as it did before.
 */
(function () {
  'use strict';

  var DRAWERS = 'cart-drawer, quick-add-drawer, side-drawer';
  var BODY_CLASS = 'f47-drawer-open';

  function anyDrawerOpen() {
    var els = document.querySelectorAll(DRAWERS);
    for (var i = 0; i < els.length; i++) {
      if (els[i].hasAttribute('open')) return true;
    }
    return false;
  }

  function sync() {
    try {
      document.body.classList.toggle(BODY_CLASS, anyDrawerOpen());
    } catch (e) {}
  }

  function observe(el) {
    if (!window.MutationObserver || el.dataset.f47DrawerWatched) return;
    el.dataset.f47DrawerWatched = '1';
    new MutationObserver(sync).observe(el, { attributes: true, attributeFilter: ['open'] });
  }

  function init() {
    try {
      document.querySelectorAll(DRAWERS).forEach(observe);
      sync();

      // Drawers can be re-rendered by the theme (the cart drawer replaces its own
      // markup on cart updates), so keep watching for replacements.
      if (window.MutationObserver) {
        new MutationObserver(function (mutations) {
          var rescan = false;
          for (var i = 0; i < mutations.length; i++) {
            if (mutations[i].addedNodes.length) { rescan = true; break; }
          }
          if (rescan) {
            document.querySelectorAll(DRAWERS).forEach(observe);
            sync();
          }
        }).observe(document.body, { childList: true, subtree: true });
      }
    } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
